import React, { useState } from 'react';
import { GECKO_CONSTS, GeckoBtn } from 'ui';
import AgentTeamSelect from 'components/AgentTeamSelect';
import TagSelect from 'components/TagSelect';
import ChannelSelect from 'components/ChannelSelect';
import ConversationStatusSelect from 'components/ConversationStatusSelect';
import buildFilterQueries from '../helpers/buildFilterQueries';
import CONSTANTS from 'chat-constants';
import './searchFilterBar.scss';
import GeckoLocation from 'services/gecko-location';

const SearchFilterBar = ({
  onApplyFilter,
  selectedAgentsAndTeams,
  selectedChannels,
  selectedTags,
  selectedStatuses,
  setSelectedAgentsAndTeams,
  setSelectedChannels,
  setSelectedTags,
  setSelectedStatuses,
}) => {
  const renderAgentTeamPicker = () => {
    return (
      <AgentTeamSelect
        value={selectedAgentsAndTeams}
        onChange={(agentsAndTeams) => {
          setSelectedAgentsAndTeams([...agentsAndTeams]);
        }}
        multi={true}
        placeholder="Filter by Agents & Teams"
        allowUnassignedOption={true}
      />
    );
  };

  const renderChannelPicker = () => {
    return (
      <ChannelSelect
        includeDeletedChannels={true}
        value={selectedChannels}
        multi={true}
        onChange={(channels) => setSelectedChannels([...channels])}
        placeholder="Filter by Channels"
        allowedChannelTypes={[
          ...CONSTANTS.CHANNEL.PICKABLE_TYPES,
          CONSTANTS.CHANNEL.TYPE_FORM_RESPONSE,
        ]}
      />
    );
  };

  const renderTagPicker = () => {
    return (
      <TagSelect
        value={selectedTags}
        multi={true}
        onChange={(tags) => setSelectedTags([...tags])}
        placeholder="Filter by Tags"
      />
    );
  };

  const renderConversationStatusSelect = () => {
    return (
      <ConversationStatusSelect
        value={selectedStatuses}
        multi={true}
        onChange={(statuses) => setSelectedStatuses([...statuses])}
        placeholder="Filter by Status"
      />
    );
  };

  const setParams = () => {
    const agentParams = selectedAgentsAndTeams
      .filter((i) => i.startsWith('agent'))
      .map((a) => a.replace('agent_', ''));

    const teamParams = selectedAgentsAndTeams
      .filter((i) => i.startsWith('team'))
      .map((a) => a.replace('team_', ''));

    const queryString = GeckoLocation.params;

    const filterParams = {
      ...(selectedTags.length > 0 && { tag: selectedTags }),
      ...(selectedChannels.length > 0 && { channel: selectedChannels }),
      ...(selectedStatuses.length > 0 && { status: selectedStatuses }),
      ...(agentParams.length > 0 && { agent: agentParams }),
      ...(teamParams.length > 0 && { team: teamParams }),
    };

    GeckoLocation.goTo(GeckoLocation.location.pathname, {
      search: queryString['search'],
      ...filterParams,
    });
  };

  const renderFilterButton = () => {
    return (
      <GeckoBtn
        name="Apply Filters"
        icon="far fa-sliders-h"
        type={GECKO_CONSTS.BTN_TYPE_PRIMARY}
        handler={() => {
          setParams();
          onApplyFilter(
            buildFilterQueries(
              selectedTags,
              selectedChannels,
              selectedStatuses,
              selectedAgentsAndTeams
            )
          );
        }}
      />
    );
  };

  return (
    <div className="searchFilterBar">
      <div className="filter-section">
        <div className="filter-settings">
          <div className="filterCell">{renderAgentTeamPicker()}</div>
          <div className="filterCell">{renderChannelPicker()}</div>
          <div className="filterCell">{renderTagPicker()}</div>
          <div className="filterCell">{renderConversationStatusSelect()}</div>
          <div className="filterCell">{renderFilterButton()}</div>
        </div>
      </div>
    </div>
  );
};

export default SearchFilterBar;
